module.exports = __webpack_public_path__ + "2a1c055c122198b6a93049117824c00d.png";